import type { Shape } from './store'

import { createContext, useRef } from 'react'

import { createDatasheetStore } from './store'

type DatasheetStore = ReturnType<typeof createDatasheetStore>
export const DatasheetContext = createContext<DatasheetStore | null>(null)

type DatasheetProviderProps = {
	children: React.ReactNode
} & Partial<Shape>
export const DatasheetProvider = ({
	children,
	...initialState
}: DatasheetProviderProps) => {
	const storeRef = useRef<DatasheetStore | undefined>(undefined)

	if (!storeRef.current)
		storeRef.current = createDatasheetStore({ ...initialState })

	return (
		<DatasheetContext value={storeRef.current}>{children}</DatasheetContext>
	)
}
